<template>
    <v-chip v-if="hasSet" variant="flat" :color="typeColour" size="x-small">
        <v-icon v-if="typeIcon" start :icon="typeIcon"></v-icon>
        <span v-html="typeDescription"></span>
    </v-chip>
</template>
<style scoped>

</style>
<script>
    import { getColourFromInt } from '../../mixins/colourMixins'
    function initialState() {
        return {
            loading: false
        };
    }
    export default {
        name: "WarrantyTypeChip",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            status: Number,
        },
        methods: {
        },
        computed: {
            typeSet() {
                return this.$constants.jobs.warrantyStatuses[this.status];
            },
            hasSet() {
                return this.typeSet !== null && typeof this.typeSet !== "undefined";
            },
            typeColour() {
                if (this.hasSet && this.typeSet.colour !== null && typeof this.typeSet.colour !== 'undefined'){
                    return this.typeSet.colour;
                } else {
                    return getColourFromInt(this.status);
                }
                
            },
            typeIcon() {
                if (!this.hasSet)
                    return null;
                return this.typeSet.icon;
            },
            typeDescription() {
                if (!this.hasSet)
                    return null;
                let desc = this.typeSet.title;
                return desc;
            }
        }
    };
</script>